/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CheckEquipment from '@/components/CheckEquipment1';
import { hdProjectProductGetInfoByCode, addcomplaint } from '@/api';
import XInput from "vux/src/components/x-input/index.vue";
import Group from "vux/src/components/group/index.vue";
import XTextarea from "vux/src/components/x-textarea/index.vue";
import XButton from "vux/src/components/x-button/index.vue";
export default {
  name: "complaint",
  components: {
    CheckEquipment: CheckEquipment,
    XInput: XInput,
    Group: Group,
    XTextarea: XTextarea,
    XButton: XButton
  },
  data: function data() {
    return {
      project_id: "",
      form: {
        hdProducts: []
      },
      productname: "",
      product_code: "",
      neirong: "",
      xingming: "",
      telephone: "",
      fkTProductionId: "",
      a: false
    };
  },
  methods: {
    CheckEquipment: function CheckEquipment() {
      var _this = this;

      var data = {
        code: this.productname,
        pageNo: 0,
        pageSize: 10
      };
      hdProjectProductGetInfoByCode(data).then(function (res) {
        if (res.data.info.items.length > 0) {
          _this.$vux.toast.text("查询成功");

          _this.productname = res.data.info.items[0].code;
          _this.product_code = res.data.info.items[0].contractNo;
          _this.fkTProductionId = res.data.info.items[0].id;
          _this.project_id = res.data.info.items[0].projectId;
        } else {
          _this.$vux.toast.text("设备号为空，请输入正确设备号");
        }
      });
    },
    tijiao: function tijiao() {
      var _this2 = this;

      if (this.neirong == "" || this.xingming == "" || this.telephone == "") {
        this.$vux.toast.text("请填写完整信息");
        return;
      }

      var data = {
        source: 3,
        fkTProductionId: this.fkTProductionId,
        fkTProjectId: this.project_id,
        content: this.neirong,
        name: this.xingming,
        phone: this.telephone
      };
      console.log(data);
      addcomplaint(data).then(function (res) {
        if (res.data.code == 0) {
          _this2.$vux.toast.text("提交成功");

          _this2.$router.back();
        } else {
          _this2.$vux.toast.text(res.data.msg);
        }
      });
    }
  },
  created: function created() {}
};